import React, { useEffect } from 'react';
import { Card, Empty, Select, Space, Spin } from 'antd';
import { useTranslation } from 'react-i18next';
import axios from 'axios';

export default function TopProducts() {
  const { t } = useTranslation();
  const [topUsers, setTopUsers] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [dateFilter, setDateFilter] = React.useState('daily');

  useEffect(() => {
    const controller = new AbortController();

    const fetchTopUsers = async () => {
      setLoading(true);
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/v1/dashboard/quickgift/top-users-list?dateFilter=${dateFilter}`,
          {
            signal: controller.signal,
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')}`,
            },
          }
        );

        setTopUsers(response.data.data);
      } catch (error) {
        if (axios.isCancel(error)) return;
        console.error('Error fetching top users:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchTopUsers();

    return () => controller.abort();
  }, [dateFilter]);

  const handleDateFilterChange = (value) => {
    console.log('Date filter changed to:', value);
    setDateFilter(value);
  };

  const filterOptions = [
    { value: 'all', label: t('all') },
    { value: 'daily', label: t('today') },
    { value: 'weekly', label: t('this.week') },
    { value: 'monthly', label: t('this.month') },
  ];

  const getRankStyle = (index) => {
    const styles = {
      0: {
        color: '#faad14',
        background: '#fffbe6',
        borderColor: '#ffe58f',
      },
      1: {
        color: '#8c8c8c',
        background: '#fafafa',
        borderColor: '#d9d9d9',
      },
      2: {
        color: '#cf9463',
        background: '#fff7e6',
        borderColor: '#ffd591',
      },
    };
    return styles[index] || {};
  };

  const getRankLabel = (index) => {
    const labels = ['1st', '2nd', '3rd'];
    return labels[index] || '';
  };

  return (
    <Card
      title={t('top.users')}
      extra={
        <Space>
          <Select
            value={dateFilter}
            size='small'
            style={{ minWidth: 110 }}
            onChange={handleDateFilterChange}
          >
            {filterOptions.map((option) => (
              <Select.Option key={option.value} value={option.value}>
                {option.label}
              </Select.Option>
            ))}
          </Select>
        </Space>
      }
    >
      {loading ? (
        <div className='loader'>
          <Spin />
        </div>
      ) : (
        <div style={{ overflowY: 'auto', maxHeight: 370 }}>
          {console.log('Rendering with topUsers:', topUsers)}
          {topUsers.length ? (
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '12px',
                padding: '8px 4px',
              }}
            >
              {topUsers.slice(0, 3).map((item, idx) => {
                const rankStyle = getRankStyle(idx);
                return (
                  <div
                    key={idx}
                    style={{
                      background: rankStyle.background,
                      borderRadius: '8px',
                      padding: '16px',
                      border: `1px solid ${rankStyle.borderColor}`,
                      transition: 'all 0.3s ease',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                    }}
                  >
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '12px',
                      }}
                    >
                      <div
                        style={{
                          width: '32px',
                          height: '32px',
                          borderRadius: '50%',
                          background: rankStyle.color,
                          color: '#fff',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          fontSize: '14px',
                          fontWeight: 'bold',
                        }}
                      >
                        {getRankLabel(idx)}
                      </div>
                      <div>
                        <div
                          style={{
                            fontSize: '16px',
                            fontWeight: 500,
                            color: '#262626',
                            marginBottom: '4px',
                          }}
                        >
                          {item.full_name}
                        </div>
                      </div>
                    </div>
                    <div
                      style={{
                        textAlign: 'right',
                        padding: '4px 12px',
                        borderRadius: '16px',
                        background: '#fff',
                        boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
                      }}
                    >
                      <div
                        style={{
                          fontSize: '12px',
                          color: '#8c8c8c',
                          marginBottom: '2px',
                        }}
                      >
                        {t('total.purchases')}
                      </div>
                      <div
                        style={{
                          fontSize: '16px',
                          fontWeight: 'bold',
                          color: rankStyle.color,
                        }}
                      >
                        {item.total_purchases}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          ) : (
            <Empty />
          )}
        </div>
      )}
    </Card>
  );
}
